module.exports = __webpack_public_path__ + "static/media/2_3.da508932.png";